import { ISiteLeadVisits } from '@components/SiteLeadOverview';
import { create, StateCreator } from 'zustand';
import { persist, PersistOptions } from 'zustand/middleware';

interface IEndUserStore {
	refGlider: React.RefObject<HTMLLIElement> | null;
	setGliderRef: (value: React.RefObject<HTMLLIElement>) => void;
	activeNavTabs: number[];
	setActiveNavTab: (value: number[]) => void;
	resetNavTabs: () => void;
	isEditing: boolean;
	isFormEdit: boolean;
	formId: number | null;
	formRevalidate?: boolean | null;
	selectedSubContractor?: string[];
	setSelectSubContractor?: (value: string[]) => void;
	setIsEditing: (val: boolean) => void;
	setIsFormEdit: (val: boolean) => void;
	setFormId: (val: number | null) => void;
	setFormRevalidate: (val: boolean | null) => void;
	activeTabIndex: number;
	setActiveTabIndex: (index: number) => void;
	isConvertingUpcomingToActive: boolean;
	setIsConvertingUpcomingToActive: (val: boolean) => void;
	setVisitData: (val: ISiteLeadVisits) => void;
	visitData: ISiteLeadVisits | null;
}

const initialState = {
	refGlider: null,
	activeNavTabs: [0],
	isEditing: false,
	isFormEdit: false,
	formId: null,
	formRevalidate: false,
	activeTabIndex: 0,
	isConvertingUpcomingToActive: false,
	visitData: null,
};

type EnduserPersistOptions = PersistOptions<IEndUserStore, Partial<IEndUserStore>>;

export const useEndUserStore = create<IEndUserStore>(
	(
		persist as unknown as (
			config: StateCreator<IEndUserStore>,
			options: EnduserPersistOptions
		) => StateCreator<IEndUserStore>
	)(
		(set) => ({
			...initialState,
			setGliderRef: (value: React.RefObject<HTMLLIElement>): void => set((state) => ({ ...state, refGlider: value })),
			setActiveNavTab: (value: number[]): void => set((state) => ({ ...state, activeNavTabs: value })),
			resetNavTabs: (): void => set((state) => ({ ...state, activeNavTabs: [0] })),
			setIsEditing: (val: boolean): void => set((state) => ({ ...state, isEditing: val })),
			setIsFormEdit: (val: boolean): void => set((state) => ({ ...state, isFormEdit: val })),
			setFormId: (val: number | null): void => set((state) => ({ ...state, formId: val })),
			setFormRevalidate: (val: boolean | null): void => set((state) => ({ ...state, formRevalidate: val })),
			setSelectSubContractor: (val: string[]): void => set((state) => ({ ...state, selectedSubContractor: val })),
			setActiveTabIndex: (index): void => set({ activeTabIndex: index }),
			setIsConvertingUpcomingToActive: (val: boolean): void =>
				set((state) => ({ ...state, isConvertingUpcomingToActive: val })),
			setVisitData: (val: ISiteLeadVisits): void => set((state) => ({ ...state, visitData: val })),
		}),
		{
			name: 'enduser-storage',
			partialize: (state) => ({
				activeNavTabs: state.activeNavTabs,
				isFormEdit: state.isFormEdit,
				formId: state.formId,
				isEditing: state.isEditing,
				formRevalidate: state.formRevalidate,
				isConvertingUpcomingToActive: state.isConvertingUpcomingToActive,
			}),
		} as EnduserPersistOptions
	)
);
